<header class="admin-header">
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <img class="img-header-logo" routerLink="/admin/home" src="assets/images/logo-white.png" alt="Mega Autos" />
            </div>
            <div class="col-md-6 col-header-links">
                <a class="link" routerLink="/admin/home">Veículos</a>
                <a class="link" routerLink="">Site</a>
                <a class="link" (click)="logout()">Sair</a>
            </div>
        </div>
    </div>
</header>
<main class="main-content">
    <div class="container">
        <router-outlet></router-outlet>
    </div>
</main>